import {hasValue} from '@shared/utils/helpers';

export class CoreResponse<T = any> {
  errors: any;
  body: T;
  headers: any;
  status: number;

  constructor(res: any) {
    // Ensuring res is not null (logout pushes a null res object into params), therefore forcing default val of {}
    res = res !== null ? res : {};

    this.body = res.body ? res.body : null;

    // Temporary hack for inconsistent data returning (where the data returned doesn't contain "{body: {}}"
    if (!this.body) {
      if (Object.keys.length > 0) {
        this.body = res;
        this.status = 200;
      }
    } else {
      this.status = res.status ? res.status : null;
    }
    this.headers = res.headers ? res.headers : null;
  }

  public get success(): boolean {
    return this.status === 200 && !hasValue(this.errors);
  }
}
